import growlApi from '../../../Util/growler';
import getResource from '../../../Util/resources';

function formatInputText(text){
    //Flatten arrays into a single string
    return Array.isArray(text) ? text.join('\n') : text;
}

function error(text){
    growlApi.bootstrapDanger(formatInputText(text));
}

// eslint-disable-next-line no-unused-vars
function success(text){
    growlApi.bootstrapSuccess(formatInputText(text));
}

function information(text){
    growlApi.bootstrapInfo(formatInputText(text));
}

function fileCreatedNotification(){
    information(getResource('MediaLibrary_FileCreated_Notification'));
}

function fileDeletedNotification(){
    information(getResource('MediaLibrary_FileDeleted_Notification'));
}

function folderCreatedNotification(){
    information(getResource('MediaLibrary_FolderCreated_Notification'));
}

function folderDeletedNotification(){
    information(getResource('MediaLibrary_FolderDeleted_Notification'));
}

function imageCroppedNotification(){
    information(getResource('MediaLibrary_ImageCropped_Notification'));
}

export {
    error,
    fileCreatedNotification,
    fileDeletedNotification,
    folderCreatedNotification,
    folderDeletedNotification,
    imageCroppedNotification
};